import cn from "@/util/cn";
import { ComponentProps } from "react";

export type TextareaProps = ComponentProps<"textarea">;

const Textarea = ({ className, ...props }: TextareaProps) => (
  <textarea
    className={cn(
      "focus-visible:ring-blue-500/50 flex min-h-20 w-full rounded-md border px-3 py-2 placeholder:text-primary/60 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  />
);

Textarea.displayName = "Textarea";

export default Textarea;
